module.exports = __webpack_public_path__ + "img/img4_7.90afbea4.jpeg";